import script from "./DataIngestionTodayAlerts.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataIngestionTodayAlerts.vue?vue&type=script&setup=true&lang=ts"

import "./DataIngestionTodayAlerts.vue?vue&type=style&index=0&id=a453ea02&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a453ea02"]])

export default __exports__